import Swal from 'sweetalert2/src/sweetalert2.js';
import '@sweetalert2/theme-dark/dark.scss';

export default Swal;
